module.exports = __webpack_public_path__ + "img/banner.d37ce816.jpg";